<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    :subtitle="connectedService.name"
    @on-confirm="sync"
    @on-cancel="hide()"
    :okText="$t('Sync')"
    :closeText="$t('Close')"
  >
    <v-card flat class="my-0">
      <v-card-text>
        <div v-for="(param, index) in connectedService.syncParams" :key="index">
          <v-switch
            v-if="isBoolParam(param.value)"
            v-model="param.value"
            :label="paramLabel(param.name)"
            color="primary"
          ></v-switch>
          <v-text-field
            v-else
            :label="paramLabel(param.name)"
            v-model="param.value"
          ></v-text-field>
        </div>
      </v-card-text>
    </v-card>
  </base-modal>
</template>
<script>
import ConnectedServiceService from "@/services/ConnectedServiceService";
import ConnectedService from "@/ecm/models/connectedService/ConnectedService";
import startCase from "lodash/startCase";
import Utils from "@/ecm/common/Utils";

export default {
  name: "ConnectedServiceSyncModal",
  created() {
    ConnectedServiceService.getList().then((data) => {
      this.serviceList = data;
    });
  },
  data() {
    return {
      serviceList: [],
      modal: {
        title: this.$t("Sync"),
        key: "connectedServiceSyncModal",
      },
      open: false,
      connectedService: new ConnectedService(),
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    modalTitle() {
      return (
        this.modal.title +
        (this.connectedService.description
          ? " - " + this.connectedService.description
          : "")
      );
    },
  },
  methods: {
    sync() {
      this.modalInstance.progress(true);
      ConnectedServiceService.sync(this.connectedService.toDto())
        .then((result) => {
          if (result && result.length > 0) {
            var errorMessage = `${this.$t(
              "SyncFinishedWithErrors"
            )}:\n ${result.join("\n - ")}`;
            Utils.toast.warning(errorMessage);
          } else {
            Utils.toast.success(this.$t("SyncFinishedSuccessfully"));
          }
          this.hide();
          this.$emit("on-sync");
        })
        .catch()
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    isBoolParam(paramValue) {
      return paramValue == false || paramValue == true;
    },
    paramLabel(paramName) {
      return startCase(paramName).replace("Sync", this.$t("Sync"));
    },
    edit(dto) {
      dto.SyncParams = this.serviceList.find(
        (x) => x.ServiceName == dto.ServiceName
      ).SyncParams;
      this.connectedService = new ConnectedService(dto);
      this.show();
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
};
</script>
